export default {
  data: () => ({
    eKartParams: {
      host: {
        name: 'host',
        dataType: {
          name: 'text',
        },
        translationPath: 'admin.waterModelingEkartParams.host',
      },
      port: {
        name: 'port',
        dataType: {
          name: 'text',
        },
        translationPath: 'admin.waterModelingEkartParams.port',
      },
      user: {
        name: 'user',
        dataType: {
          name: 'text',
        },
        translationPath: 'admin.waterModelingEkartParams.user',
        autocomplete: 'new-password',
      },
      password: {
        name: 'password',
        dataType: {
          name: 'text',
        },
        translationPath: 'admin.waterModelingEkartParams.password',
        type: 'password',
        autocomplete: 'new-password',
      },
      dbname: {
        name: 'dbname',
        dataType: {
          name: 'text',
        },
        translationPath: 'admin.waterModelingEkartParams.dbname',
      },
      schema: {
        name: 'schema',
        dataType: {
          name: 'text',
        },
        translationPath: 'admin.waterModelingEkartParams.schema',
      },
      nodes_table: {
        name: 'nodes_table',
        dataType: {
          name: 'text',
        },
        translationPath: 'admin.waterModelingEkartParams.nodes_table',
      },
      links_table: {
        name: 'links_table',
        dataType: {
          name: 'text',
        },
        translationPath: 'admin.waterModelingEkartParams.links_table',
      },
    },
  }),
  computed: {
    eKartParamsKeys() {
      return Object.keys(this.eKartParams);
    },
  },
};
